class PendingOrdersNotificationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'PendingOrdersNotification';

        super(entityName);

        const options = Monet.Grid.Utils.paginationOptions;
        if (!App.Forms.PendingOrdersNotification) {
            App.Forms.PendingOrdersNotification = {
                layout: {},
                dataMapper: null,
                pagination: {
                    first: options.FIRST,
                    max: options.MAX_RESULT,
                    blocked: false,
                    canIncrement: true
                },
                columnToOrders: [],
                controlUpdater: null,
                notification: null
            };
        }

        if (!App.Objects.PendingOrdersNotification) {
            App.Objects.PendingOrdersNotification = this;
        }

        if (!Monet.Session.PendingOrdersNotification) {
            Monet.Session.PendingOrdersNotification = {
                mapLayerIsChecked: false
            };
        }
    }

    updateGrid = (filter, callback, appendCollection, action) => {
        let  error = null,
            _filter = {},
            that = this,
            pagination = {},
            columns,
            fields,
            pendingOrders,
            projectionBuilder,
            processProjection;

        try {
            if (filter) {
                _filter = filter;
            }

            if (action === 'update') {
                var firstResult = 0;
                var pages;
                var updater;
                var page;
                var options;

                options = Monet.Grid.Utils.paginationOptions;
                updater = App.Forms.PendingOrdersNotification.controlUpdater;
                page = updater.getPageByScrollPosition();
                pages = updater.getPages();

                if (page !== 0) {
                    firstResult = pages[page].firstResult;
                }

                pagination.first = firstResult;
                pagination.max = options.MAX_RESULT;
            } else {
                pagination = App.Forms.PendingOrdersNotification.pagination;
            }

            pendingOrders = new App.Collections.PendingOrders();
            projectionBuilder = new Monet.Builder.Projection();
            fields = Greenmile.PendingOrdersNotification.Utils.fieldsToProjection;
            projectionBuilder.setPagination(pagination);
            projectionBuilder.addFields(fields);

            processProjection = projectionBuilder.projection.toString();
            columns = App.Forms[this.entityName].table.getColumns();
            pendingOrders.filterWithRestrictions({
                filter: _filter,
                criteria: processProjection,
                success: function (result) {
                    if (callback) {
                        callback(that.entityName, columns, result, true);
                    }
                }
            });
        } catch (e) {
            error = new Monet.Exception.ReturnError(this, 'Error on update grid pending orders notification', e);
            error.console();
        }
    }

    getFilter = () => {
        const filter = Greenmile.PendingOrdersNotification.Utils.filterBasic;
        const columnToOrders = App.Forms.PendingOrdersNotification.columnToOrders;
        const columnSize = columnToOrders.length;

        if (columnSize) {
            filter['sort'] = [];

            for (let i = 0; i < columnSize; i++) {
                filter.sort.push({
                    attr: columnToOrders[i].field,
                    type: columnToOrders[i].order
                });
            }
        }
        return filter;
    }

    assignToRoute = (routeId, data, { callbackSuccess, callbackError }) => {
        const assign = new Monet.Ajax();
        assign.url = `Route/${routeId}/AddStopByPendingOrder`;
        assign.method = 'POST';
        assign.data = data;
        assign.success = (result) => {
            if (result && callbackSuccess) {
                callbackSuccess();
            }
        };
        assign.error = (xhr) => {
            if (xhr.status === 403) {
                Monet.Configurations.errorNotification(null, xhr, null, null);
            } else if (callbackError) {
                callbackError(JSON.parse(xhr.response));
            }
        };
        assign.send();
    }

    getFieldsToGridLayout = () => {
        try {
            const ajax = new Monet.Ajax();
            ajax.url = 'form/Maps/grid_pending_orders_notification';
            ajax.success = function (data) {
                if (data) {
                    App.Forms.PendingOrdersNotification.layout['index'] = data;
                }

                $('#loading_img').hide();
            };

            ajax.error = function (response) {
                Monet.Configurations.errorNotification(null, response);
                $('#loading_img').hide();
            };

            ajax.send();
            $('#loading_img').show();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, 'Error on get grid layout to pending orders notification');
            error.console();
        }
    }
}

App.Routers.PendingOrdersNotification = PendingOrdersNotificationRouter;